import HoursInput from './HoursInput.jsx';
import {
    formatInternalDate,
    formatTime,
    ShortDaysOfWeek,
} from '../../lib/DateTime.js';
import PopoverButton from '../PopoverButton.jsx';
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline/index.js';
import { useState } from 'react';
import CopyHoursButton from './CopyHoursButton.jsx';

const DayOfWeekRow = ({
    label,
    dayNumber,
    hours,
    setHours,
    onCopyHours,
    isEditing,
}) => {
    const isChecked = hours && hours.length > 0;

    const defaultHours = [{ start: '09:00', end: '17:00' }];

    function toggle() {
        if (isChecked) {
            setHours([]);
        } else {
            setHours(defaultHours);
        }
    }

    return (
        <div className="flex items-start pb-4">
            <div className="flex items-center mt-2">
                {isEditing && (
                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={toggle}
                        className="mr-3"
                    />
                )}
                <div className="font-semibold uppercase w-12">{label}</div>
            </div>

            <div className="flex-1">
                {isEditing && (
                    <HoursInput
                        hours={hours}
                        setHours={setHours}
                        rightBtnContent={
                            <CopyHoursButton
                                onCopy={toDays => onCopyHours(hours, toDays)}
                                skipDay={dayNumber}
                            />
                        }
                    />
                )}
                {!isEditing && (
                    <div>
                        {!hours?.length && (
                            <div className="text-gray-500 mt-2">
                                Unavailable
                            </div>
                        )}
                        {hours.map((hoursSet, idx) => (
                            <div className="mt-2" key={idx}>
                                {formatTime(
                                    `${formatInternalDate(new Date())} ${hoursSet.start}`,
                                )}{' '}
                                -{' '}
                                {formatTime(
                                    `${formatInternalDate(new Date())} ${hoursSet.end}`,
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

const WeeklyHours = ({ availability, setAvailability, isEditing }) => {
    function onCopyHours(hours, toDays) {
        const newAvailability = { ...availability };
        for (const i of toDays) {
            // Deep copy so hours not linked
            newAvailability[i] = JSON.parse(JSON.stringify(hours));
        }

        setAvailability(newAvailability);
    }

    return (
        <div>
            {ShortDaysOfWeek.map((dow, idx) => (
                <DayOfWeekRow
                    key={idx}
                    dayNumber={idx}
                    label={dow}
                    hours={availability[idx] || []}
                    setHours={newHours => {
                        const newAvailability = { ...availability };
                        //console.log('before update', newAvailability)
                        newAvailability[idx] = newHours;
                        //console.log('setting idx', idx, newHours, newAvailability)
                        setAvailability(newAvailability);
                    }}
                    isEditing={isEditing}
                    onCopyHours={onCopyHours}
                />
            ))}
        </div>
    );
};

export default WeeklyHours;
